<template>
  <div class="page-productDetails-m" @click.stop="closeShade">
     <Header-m></Header-m>
     <div class="productDetails-banner"></div>
     <mt-navbar v-model="active">
  <mt-tab-item v-for="(value) in title" :key="value.id" :id="value.id" @click="tabTiele(v)" >{{value.name}}</mt-tab-item>
</mt-navbar>
<!-- tab-container -->
<mt-tab-container class="mt-tab-container" v-model="active" swipeable="swipeable">
  <mt-tab-container-item id="1">
   <div class="productDetails-nb">
      <div class="productDetails-describe-1"></div>
      <div class="productDetails-describe-2"></div>
      <div class="productDetails-describe-3"></div>
    </div>
  </mt-tab-container-item>
  <mt-tab-container-item id="2">
    <div class="productDetails-iot">
      <div class="productDetails-describe-1"></div>
      <div class="productDetails-describe-2"></div>
      <div class="productDetails-describe-3"></div>
    </div>
  </mt-tab-container-item>
  <mt-tab-container-item id="3">
    <div class="productDetails-admin">
      <div class="productDetails-describe-1"></div>
      <div class="productDetails-describe-2"></div>
      <div class="productDetails-describe-3"></div>
    </div>
    
    <div class="productDetails-try-wrap ui-flex ui-flex-justify-center">
      <div class="productDetails-try ui-flex ui-flex-justify-center ui-flex-align-center">
        <span class="try-word" @click="jump('/try_m')">点击试用，解锁更多功能</span>
        <i class="try-icon"></i>
      </div>
    </div>
  </mt-tab-container-item>
</mt-tab-container>

    
      <Menu path="/productCenter_m" ref="closeShade"></Menu>
  </div>

</template>
<script>
  import HeaderM from '@/components/wap/HeaderM/index.vue'
  import Menu from '@/components/wap/Menu/index.vue'
  import router from '@/router'
  import { Navbar, TabItem ,TabContainer, TabContainerItem } from 'mint-ui';
  export default {
    components: {
      HeaderM,
      Menu,
    },
    
    data() {
      return {
        title:[
          {id:'1',name:'NB智能燃气表'},
          {id:'2',name:'IoT智能燃气表'},
          {id:'3',name:'智能燃气管理平台'},
        ],
        active:this.$route.query.type?this.$route.query.type:'1',
        
        swipeable:true,
      }
    },
    beforeCreate(){
      require('../../../static/js/adaptation.js')
    },
    methods: {
       /**
       * 点击跳转
      */
      jump (value) {

        router.push({
          path: value,
        }).catch(err => {
          console.log(err)
        })
        

      },
      
      tabTiele(v){
        this.active=v.id
      },
      closeShade(){
        this.$refs.closeShade.closeShade();
      },
    },
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>